import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { NeonChristmasMarketplaceBanner } from 'components/NeonChristmas/NeonChristmasMarketplaceBanner';
import { FirstTime } from 'components/forYou/FirstTime';
import { useDismissFirstTime } from 'components/forYou/FirstTime/useDismissFirstTime';
import { PromotionalEvents } from 'components/forYou/PromotionalEvents';

import {
  MarketBannerQuery,
  MarketBannerQueryVariables,
} from './__generated__/index.graphql';

const MARKET_BANNER_QUERY = gql`
  query MarketBannerQuery($sport: Sport!) {
    tokens {
      promotionalEvents(sport: $sport) {
        slug
        ...PromotionalEvents_PromotionalEvent
      }
    }
  }
  ${PromotionalEvents.fragments.PromotionalEvent}
` as TypedDocumentNode<MarketBannerQuery, MarketBannerQueryVariables>;

export const MarketBanners = () => {
  const {
    flags: { useNeonChristmas = false },
  } = useFeatureFlags();
  const { sport } = useSportContext();
  const { data } = useQuery(MARKET_BANNER_QUERY, {
    variables: { sport },
  });
  const { hasDismissed } = useDismissFirstTime();

  if (!hasDismissed) {
    return <FirstTime />;
  }

  if (useNeonChristmas && sport !== Sport.BASEBALL) {
    return <NeonChristmasMarketplaceBanner />;
  }

  const promotionalEvents = data?.tokens.promotionalEvents;
  if (promotionalEvents?.length) {
    return <PromotionalEvents promotionalEvents={promotionalEvents} />;
  }
  return null;
};
